/* 
App constants declarations
*/

//Baseurl for the web Api

//Production
export var baseUrl = "https://www.ileadnam.com/api";

// export var baseUrl = "https://www.ileadnam.com/dev-iLead/api";

//Dev
// export var baseUrl = "http://localhost:62581";

//App Id for the ILead application
export const AppId = "80D41672-6E93-4FEE-99A0-21D0ED24193A";

//Clear the local storage
export const clearStorage = () => {
  localStorage.clear();
};

// Get the user id from the localstorage after authenticate the user
export const GetUserId = () => {
  let userStorge = localStorage.getItem("userDetails")
    ? JSON.parse(localStorage.getItem("userDetails"))
    : {};

  let UserID = "UserID" in userStorge ? userStorge.UserID : "";
  return UserID ? UserID : "";
};

/*
 * Get the user details from the local storage
 */
export const GetUserDetails = () => {
  let userStorge = localStorage.getItem("userDetails")
    ? JSON.parse(localStorage.getItem("userDetails"))
    : {};

  return userStorge;
};

/*
 * Get the user roles
 */
export const GetUserRoles = () => {
  let roles = ["Manager", "Leader", "Admin"];
  return roles;
};
